export default function extractInclusionCriteria(criteria: string) {
  // Exclusion criteria is not consistently cased, so lowercase everything
  const tempString = criteria.slice().toLowerCase()
  const exclusionStart = tempString.indexOf('exclusion criteria')

  return criteria.slice(0, exclusionStart)
}
